/* Base translations · Planning (TCWG, materiality, plan, journal-entry testing) — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): tcwg, materiality, plan, a9001, a9002. */
export const I18N_BASE_PLANNING = {
  en: {
    tcwg: {
      auditWriteFailed: "Could not record the communication in the audit trail. The row was not saved.",
      // C3b · N2 — 311(a) communication-log UI labels.
      tableHint: "Add / edit only. Nothing is deleted (ISA 230).",
      addBtn: "Add matter",
      empty: "No communications logged yet.",
      savedOk: "Communication saved.",
      errCategoryRequired: "Category is required.",
      errMatterRequired: "Matter is required.",
      col: {
        category: "Category",
        matter: "Matter",
        linkedRef: "Linked ref",
        date: "Date",
        mode: "Mode",
        to: "Communicated to",
        toRole: "Role",
        response: "Response",
        followup: "Follow-up",
      },
      cat: {
        auditor_responsibilities: "Auditor's responsibilities",
        planned_scope_and_timing: "Planned scope and timing",
        significant_findings: "Significant findings",
        independence_listed: "Independence (listed entities)",
        other: "Other",
      },
      mode: {
        oral: "Oral",
        written: "Written",
      },
      w9AddBtn: "Add to 311(a) log",
      w9ChipPrefix: "Logged in 311(a):",
      // U2 · category translations for W11 detail + log-card rendering.
      category: {
        significant_findings: "Significant findings",
        auditor_responsibilities: "Auditor's responsibilities",
        planned_scope: "Planned scope and timing",
        significant_difficulties: "Significant difficulties",
        management_letter: "Management letter",
        independence: "Independence matters",
        misstatements: "Misstatements",
        other: "Other",
      },
      // S1 — flat W13 keys so `t("w13.action.tcwg_311a_log_added")`
      // resolves to Arabic in AuditTrail.jsx (which uses that path).
      "w13.action.tcwg_311a_log_added": "311(a) log row added",
      "w13.action.tcwg_311a_log_patched": "311(a) log row edited",
      "w13.action.tcwg_311a_log_backfilled": "Backfilled — original audit write failed",
      "w13.entity.tcwg_311a_log": "311(a) communication log",
      // C3b · P3/P5 — labels + review-mode notes.
      sectionTitle: "Communication log",
      saveFailed: "Could not save the communication. Please try again.",
      reviewNote: "This is a Review engagement (practitioner scope) — the log stays active; use review wording.",
      reviewBanner: "Review engagement — practitioner-scope communications with those charged with governance.",
      catReview: {
        // On Review engagements the "Auditor's responsibilities"
        // category is relabelled as "Practitioner's responsibilities".
        auditor_responsibilities: "Practitioner's responsibilities",
      },
      // Q6 — readable label + destination for known linked-refs so
      // the log card doesn't show raw keys like "W9-tcwg-communicated".
      linkedRefs: {
        "W9-tcwg-communicated": {
          label: "W9 — Communicated to those charged with governance",
          href: "/completion/misstatements",
        },
      },
      // Q6 — English labels for the tcwg_311a W13 action codes.
      w13Actions: {
        tcwg_311a_log_added: "311(a) log row added",
        tcwg_311a_log_patched: "311(a) log row edited",
        tcwg_311a_log_backfilled: "Backfilled — original audit write failed",
      },
      // Q5 — Review-engagement overrides (EN) for 311(a) form items.
      reviewOverrides: {
        section1Title: "Required communications (review engagement)",
        item_1: "The practitioner's responsibilities in relation to the review engagement have been communicated.",
        item_2: "Planned scope and timing of the review have been communicated, including significant risks identified.",
        item_3: "Significant findings from the review have been communicated, including significant qualitative aspects and significant difficulties encountered.",
        item_4: "Circumstances affecting the form and content of the practitioner's report, if any, have been communicated.",
        item_5: "Written representations being requested have been communicated.",
        item_6: "Matters relating to independence have been communicated.",
        item_7: "Uncorrected misstatements and their effect on the conclusion have been communicated (cross-ref Misstatements Summary).",
      },
    },
    materiality: {
      figuresTitle: "Materiality figures",
      priorYearRef: "Prior year (FY{fy}) — for reference only; materiality is not carried forward",
      priorOverall: "Overall materiality",
      priorPm: "Performance materiality",
      priorCt: "Clearly trivial",
      // Batch 27 · D (M37)
      ctNotSet: "Clearly trivial not set — enter the clearly-trivial %.",
      ctNotSetIn105a: "Clearly trivial not set in 105(a).",
      open105a: "Open 105(a)",
      priorBenchmark: "Benchmark",
      benchmark: "Benchmark",
      benchmarkAmount: "Benchmark amount",
      pctApplied: "Percentage applied",
      overall: "Overall materiality",
      overallCalc: "Calculated: {v}",
      savedToast: "Materiality saved",
      overrideNote: "Overridden — reason: {reason}",
      pmPct: "Performance materiality %",
      pm: "Performance materiality",
      ctPct: "Clearly trivial %",
      ct: "Clearly trivial threshold",
      specific: "Specific materiality",
      specificTitle: "Specific materiality (per FS head)",
      specificAdd: "Add row",
      specificEmpty: "No specific materiality set. Add one only if lower thresholds apply to a particular class/balance/disclosure.",
      specificFsHead: "FS head",
      specificAmount: "Amount",
      specificReason: "Reason",
      rationale: "Rationale",
      revise: "Revise materiality",
      reason: "Reason for revision",
      history: "Revision history",
      historyCols: { when: "When", who: "Who", field: "Field",
        old: "Old", new: "New", reason: "Reason" },
      fields: {
        benchmark: "Benchmark",
        amount: "Benchmark amount",
        omPct: "Overall materiality %",
        pmPct: "Performance materiality %",
        ctPct: "Clearly trivial %",
        rationale: "Rationale",
        overallMateriality: "Overall materiality",
        performanceMateriality: "Performance materiality",
        clearlyTrivial: "Clearly trivial threshold",
        migration: "Migration from Risk Assessment",
      },
      overrideReason: "Reason for overriding calculated overall figure",
      open105: "Open 105(a)",
      readOnlyBanner: "Read-only — set in 105(a)",
      migrated: "Migrated from Risk Assessment",
      newEngagementNote: "Initial values. After creation, materiality is changed only in 105(a) Materiality.",
      pmSource: "Source: 105(a)",
      benchmarks: { pbt: "Profit before tax", revenue: "Revenue",
        totalAssets: "Total assets", equity: "Equity",
        expenses: "Total expenses", other: "Other" },
    },

    plan: {
      title: "Audit Response Plan",
      empty: "No risks in the register — add risks in Risk Assessment first.",
      addPlan: "Set plan",
      specificallyResponsive: "Specifically responsive",
      controlsReliance: "Rely on controls",
      significant: "Significant risk",
      col: { risk: "Risk", fsHead: "FS head(s)", assertions: "Assertions",
              planned: "Planned procedures", status: "Response complete",
              regFsArea: "Register FS area",
              rmm: "RMM level", significant: "Significant" },
      pickHead: "Pick FS head(s)",
      pickAssertion: "Pick assertions",
      noHeads: "No FS heads mapped for this engagement.",
      library: "Procedure library (filtered)",
      picked: "Picked procedures",
      addFromLibrary: "Add to plan",
      remove: "Remove",
      nature: { tod: "Test of details", sap: "Substantive analytics", toc: "Test of controls" },
      timing: { interim: "Interim", final: "Final" },
      extent: "Extent",
      extentPh: "e.g. sample of 25 items > OM",
      wpLink: "WP link",
      wpLinkPh: "e.g. 4101-04",
      formsSection: {
        title: "Audit Response forms",
        empty: "108(a) and 202(a) are not part of this engagement yet.",
        ref: "Ref",
        name: "Form",
        folder: "Location",
        open: "Open form",
      },
      badge: {
        r1: "At least one procedure is required.",
        r1FsHead: "Pick at least one FS head so the library can filter.",
        r2: "Significant risk needs at least one specifically responsive procedure.",
        r3: "Significant risk without controls reliance needs at least one test of details.",
        cf: "Update for current year",
      },
      summary: {
        title: "Response Plan — read-only summary",
        readOnlyNote: "Fed from the Audit Response Plan · read-only",
        risk: "Risk",
        fsHead: "FS head(s)",
        assertions: "Assertion(s)",
        significant: "Significant",
        plannedCount: "Planned procedures",
        status: "Validation",
      },
    },
    a9001: {
      title: "Journal Entry Testing and Fraud Red Flags (ISA 240)",
      subtitle: "One engine · rules J1–J15 · in-period rows only.",
      runScan: "Run scan",
      lastRunAt: "Last run",
      lastRunBy: "by",
      workerOn: "Worker",
      workerOff: "Recomputed",
      outOfDate: "Out of date — re-run scan",
      settings: {
        title: "Non-working days and hours",
        weekend: "Weekend days (any combination, none or all)",
        weekdays: { 0: "Mon", 1: "Tue", 2: "Wed", 3: "Thu", 4: "Fri", 5: "Sat", 6: "Sun" },
        holidays: "Public holidays",
        addHoliday: "Add holiday",
        holidayOutside: "The public holiday must fall within the engagement period ± 1 year ({lo} to {hi}). Check the year.",
        removeHoliday: "Remove",
        workingHours: "Working hours",
        workingStart: "Start", workingEnd: "End",
        save: "Save settings",
        saved: "Settings saved.",
        holidayOutsidePeriod: "Warning: some holidays fall outside the engagement period.",
      },
      possibleDup: {
        title: "Possible duplicates — no reference / description",
        note: "Rows with matching account · amount · date but blank reference AND description; shown separately so J13 is not overstated.",
        count: "Possible duplicate rows",
      },
      dataQuality: {
        title: "Data quality — rules not assessable",
        note: "Rules below did not run on this population. Map the missing import column to remove the note.",
        needColumn: "Missing column",
        cols: {
          no_posted_time_column: "posted_time (time of posting)",
          no_user_column: "posted_by (preparer name/id)",
          no_approver_column: "approver (approver name/id)",
          no_clearly_trivial: "clearly-trivial amount in 105a",
          no_approval_limit_set: "approval-limit list in Settings",
          tb_movement_missing: "trial balance movement (upload TB)",
        },
      },
      cardStatus: { flagged: "Flags", clean: "None", notAssessable: "Not assessable" },
      cardExpand: "Expand", cardCollapse: "Collapse",
      cardXlsx: "XLSX", cardTestThese: "Test these now",
      cardDrillCols: { entryDate: "Entry date", voucher: "Voucher", account: "Account", amount: "Amount", reason: "Reason" },
      rulesPanel: {
        title: "Rules and parameters (J1–J15)",
        col: {
          code: "Code", name: "Name", detects: "What it detects",
          why: "Why it matters", exact: "Exact rule", param: "Parameter",
          denom: "Denominator", data: "Data needed", edit: "Edit",
        },
        denom: {
          inPeriod: "in-period lines", inPeriodVouchers: "in-period vouchers",
          inPeriodAccounts: "accounts posted in period",
          pairs: "voucher pairs", withUserCol: "in-period lines with user column",
          allAmounts: "in-period lines with amount",
        },
        data: {
          entryDate: "entry_date + period",
          postedTime: "posted_time (time of posting)",
          workingHrs: "weekend + holidays + working hours (Settings)",
          amounts: "amount + clearly-trivial (105a)",
          account: "account code",
          accountPair: "account pair (debit + credit)",
          desc: "description / narration",
          reversal: "same accounts + amount + opposite sign within N days",
          user: "posted_by / posted_by_role",
          tb: "trial balance movement",
          limits: "approval-limit list",
          reference: "reference (else description)",
        },
        savedToast: "Parameter saved",
        commaList: "Comma-separated list",
      },
      a9001_01_opens: "Opens with group",
      j10Title: "J10 · Completeness check (population vs TB movement)",
      j10PopulationSize: "Population",
      j10ExpectedSize: "Expected",
      j10Diff: "Diff",
      j10ReasonRequired: "Explain the difference (required to send to Sampling)",
      j10ReasonPh: "e.g. 3 opening JEs excluded per policy",
      j10Blocked: "Explain the J10 difference before sending.",
      j10NoteOptional: "Note on J10 (optional — recorded on the sampling working paper)",
      j10InfoNotAssessed: "J10 completeness not assessed — recorded on the working paper",
      j10InfoDiffers: "J10 TB reconciliation differs by {amount} — recorded on the working paper",
      j10InfoAgrees: "J10 TB reconciliation agrees — recorded on the working paper",
      pickAtLeastOne: "Pick at least one J filter.",
      filtersTitle: "J1–J15 filters",
      filtersHint: "Click filters to build the population sent to Sampling.",
      sendToSampling: "Send filtered population to Sampling",
      sendUnit: "({lines} lines · {vouchers} vouchers)", sendDisabledJ10: "Blocked: J10 TB reconciliation differs — enter a reason first", sendDisabledPick: "Select one or more filters above",
      sentToSampling: "Sent {size} rows to Sampling.",
      a9001_03_link: "Sampling records",
      a9001_04_link: "Vouching records",
      truncated: "Showing first 200 vouchers.",
      col: { voucher: "Voucher", lines: "Lines", flags: "Flags",
              entryDate: "Entry date", account: "Account", amount: "Amount" },
      enqueuing: "Starting J1–J15 scoring…",
      noScanYet: "No scan yet — click Run scan",
      chipUnits: "{lines} lines ({vouchers} vouchers)",
      dupLines: { title: "Lines stored more than once", note: "Same account, date, amount, voucher and narration — a ledger-load duplicate, counted apart from J13 (which never pairs lines of one voucher).", count: "{n} lines in {g} groups", list: "Show the lines", none: "None" },
      computedWithoutWorker: "Recomputed",
      attr: {
        J1: "Period-end window", J2: "Posted after period end",
        J3: "Weekend / holiday / after-hours", J4: "Round amount",
        J5: "Seldom-used account", J6: "Unusual account combination",
        J7: "Blank / short description", J8: "Reversal pair",
        J9: "Posting user not on the authorised list", J10: "Completeness check",
        J11: "Top-management override", J12: "Just-below approval threshold",
        J13: "Duplicate entry",
        J14: "Approver blank", J15: "Approver = poster",   // Batch 31 · item 12 (M95)
      },
      rule: {
        J1: "Entry date within N days before or after period end.",
        J2: "Posted date-time after the period end.",
        J3: "Entry date is a non-working day (weekend or holiday) or posted outside working hours.",
        J4: "Amount ≥ clearly-trivial (from 105a) and divisible by 1,000.",
        J5: "Account posted to ≤ N times during the period.",
        J6: "Debit/credit account pair seen in < N% of vouchers.",
        J7: "Description shorter than N characters.",
        J8: "Voucher reversed by a later voucher (same accounts, equal & opposite amount) within N days.",
        J9: "Posting user blank, or not on the authorised list of posting users when the list is set.",
        J10: "Total debits and credits for the period equal the TB movement.",
        J11: "Row prepared / approved by a senior-management role (default: Partner) or a named senior user.",
        J12: "Amount within a band % (default 5%) below any configured approval threshold.",
        J13: "Same account · amount · date · reference (or description) posted on two different vouchers.",
        J14: "Approver column blank on the line (only when the GL import mapped an approver column).",
        J15: "Approver is the same user as the posting user (self-approval).",
      },
      why: {
        J1: "Late adjustments right at cut-off are a classic override signal.",
        J2: "Postings dated inside the year but time-stamped after year-end deserve a look.",
        J3: "Weekend / holiday / late-night postings are unusual for a normal business.",
        J4: "Neat round amounts near the trivial line can smooth results.",
        J5: "Rarely-used accounts are common landing pads for one-off manual adjustments.",
        J6: "A pair of accounts that never occurs together elsewhere is worth asking about.",
        J7: "Blank / one-word narrations hide the business reason.",
        J8: "Post-and-reverse patterns can move balances across period-end.",
        J9: "Postings by users outside the authorised list bypass segregation of duties.",
        J10: "GL that does not tie to the trial balance movement means the population is incomplete.",
        J11: "Owners / partners posting their own entries bypass review.",
        J12: "Splitting an amount to sit just below the approval limit is a red flag.",
        J13: "The same invoice booked twice on different vouchers is a common duplicate-payment risk.",
        J14: "An entry nobody approved has had no second look.",
        J15: "An entry approved by the person who posted it bypasses segregation of duties.",
      },
      legend: {
        title: "Attribute legend",
        code: "Code", name: "Name", rule: "Rule", param: "Current parameter",
        denom: "Denominator",
        paramNote: "Parameters come from spec sheet 5 and can be edited by the audit partner.",
      },
      paramsSaved: "Parameters saved.",
      notApplicableTbOnly: "Not applicable — this engagement has a trial balance only (no general ledger journal lines). Journal entry testing needs the GL. Source: Trial Balance upload.",
      periodMissing: "Engagement period is not set — save period start/end in Engagement settings before running Journal Entry testing.",
      readCapped: "Partial scan: this scan read {read} of the {total} GL rows (the most one scan reads is {cap}). The tests and counts below cover those {read} rows only.",
      rowsRange: "Rows {from}–{to} of {total}",
      rowsPrev: "Previous",
      rowsNext: "Next",
      rowsPageOf: "Page {page} of {pages}",
      j10Debits: "Debits", j10Credits: "Credits",
      j10TbMovement: "TB movement", j10TbMissing: "TB movement not available",
      params: { show: "Edit parameters", hide: "Hide parameters" },
      paramLabel: {
        j1_window_days: "J1 window (± days)",
        j5_max_postings: "J5 max postings",
        j6_pair_pct: "J6 pair rarity (%)",
        j7_min_len: "J7 min description length",
        j8_reversal_days: "J8 reversal window (days)",
      },
      telemetry: {
        title: "Population telemetry",
        period: "Period", totalRows: "Total GL rows", parsedDates: "Rows with a parsed date",
        inPeriod: "In period", before: "Before period", after: "After period",
        j6NotAssessable: "J6 not assessable (ambiguous vouchers)",
        j9Column: "User column available",
      },
      outside: {
        show: "Show {n} entries outside the period",
        hide: "Hide entries outside the period",
        title: "Entries outside the period",
      },
      col: { voucher: "Voucher", lines: "Lines", flags: "Flags",
              entryDate: "Entry date", account: "Account", amount: "Amount" },
      // Round M3c · plain-word additions for S1/S2/S3/S4/S5/S7/S8/S10/S11.
      cardGridTitle: "Rules J1–J15",
      lineWord: "line", linesWord: "lines",
      voucherWord: "voucher", vouchersWord: "vouchers",
      popWord: "of population",
      notAssessableDash: "—",
      guardNote: "Blank-column guard: a rule becomes Not-assessable when a required column is blank on ≥ 95% of in-period rows.",
      writeOnViewNote: "Opening the page never writes — the scan only runs when you click Run scan.",
      cardParam: {
        J2: "Posted after period end",
        J3: "Weekend + holidays + working hours (Settings)",
        J4tpl: "≥ {trivial} · divisible by {mult}",
        J4tplDefault: "≥ clearly-trivial (105a) · divisible by {mult}",
        J10: "Total debits / credits vs TB movement",
        J14: "Approver column (GL import)", J15: "Approver column (GL import)",   // Batch 31 · item 12 (M95)
        j3Used: "Weekend used: {days} · working hours {start}–{end}",   // Batch 31 · item 30 (M106)
        wdShort: "Mon|Tue|Wed|Thu|Fri|Sat|Sun",
      },
      detects: {
        J1: "Journal entries dated within a small window around the period end.",
        J2: "Entries dated inside the period but time-stamped after year-end.",
        J3: "Entries booked on weekends, public holidays or outside working hours.",
        J4: "Round-sum amounts at or above the trivial line, divisible by a whole multiple.",
        J5: "Accounts that received only a handful of postings during the whole period.",
        J6: "Debit / credit account pairs that almost never appear on other vouchers.",
        J7: "Journal entries with a very short or blank description.",
        J8: "Vouchers cancelled a few days later by an equal, opposite voucher.",
        J9: "Entries where the posting user is blank, or not on the authorised list.",
        J10: "Whether the population totals match the trial-balance movement.",
        J11: "Entries prepared or approved by senior-management roles or named senior users.",
        J12: "Amounts that sit just below a configured approval threshold.",
        J13: "Same account · amount · date · reference (or description) posted on two vouchers.",
        J14: "Entries with no approver recorded.",
        J15: "Entries approved by the same user who posted them.",
      },
      reason: {
        J1: "Entry date within ±{n} days of period end.",
        J2: "Time-stamp after period end.",
        J3: "Weekend, holiday or outside working hours.",
        J4: "Round-sum amount ≥ trivial and divisible by {mult}.",
        J5: "Account posted ≤ {n} times in the period.",
        J6: "Account pair rare in this GL (< {pct}% of vouchers).",
        J7: "Description shorter than {n} characters.",
        J8: "Reversed by an opposite voucher within {n} days.",
        J9: "Posting user blank or not on the authorised list.",
        J10: "Debits / credits do not equal TB movement.",
        J11: "Prepared / approved by a senior-management role or user.",
        J12: "Amount within {pct}% below an approval threshold.",
        J13: "Duplicate — same account, amount, date and reference / description on another voucher.",
        J14: "No approver on the line.",
        J15: "Approved by the posting user.",
      },
      paramLabelPlain: {
        j1_window_days: "J1 window (± days)",
        j5_max_postings: "J5 max postings per account",
        j6_pair_pct: "J6 rarity threshold (%)",
        j7_min_len: "J7 min description length (chars)",
        j8_reversal_days: "J8 reversal window (days)",
        j4_min_amount: "J4 minimum amount (0 = use 105a trivial)",
        j4_multiple_of: "J4 divisible by",
        j9_authorised_approvers: "J9 authorised posting users",
        j11_senior_roles: "J11 senior-management roles",
        j11_senior_users: "J11 senior users",
        j12_limits: "J12 approval-limit list",
        j12_band_pct: "J12 band below limit (%)",
        j13_date_window_days: "J13 date window (± days)",
      },
      dqExplain: {
        no_posted_time_column: "Posted-time column not present — J2 / J3 after-hours cannot be tested.",
        no_user_column: "Preparer column not present — J9 and J11 cannot be tested.",
        no_approver_column: "Approver column not imported — J14 and J15 cannot be tested. Map the approver column when the GL is imported.",
        no_clearly_trivial: "Clearly-trivial amount is not set on 105(a) — J4 cannot be tested.",
        no_approval_limit_set: "No approval-limit list configured — J12 cannot be tested.",
        tb_movement_missing: "Trial-balance movement not available — J10 completeness cannot be tested.",
        column_blank_ge_95pct: "The column this rule reads is blank on ≥ 95% of in-period rows — map the correct import column.",
      },
      dqSuggest: {
        J7: "map the narration / description column",
        J9: "map the posted_by (preparer name / id) column",
        J10: "upload the trial balance",
        J11: "map the posted_by_role column",
        J13: "map the reference OR description column",
        J14: "map the approver column at GL import", J15: "map the approver column at GL import",
      },
      paramFormat: {
        j1_window_days: "± {v} days",
        j5_max_postings: "≤ {v} postings",
        j6_pair_pct: "pair < {v}% of vouchers",
        j7_min_len: "< {v} characters",
        j8_reversal_days: "reversal within {v} days",
        j4_min_amount: "min {v}",
        j4_multiple_of: "divisible by {v}",
        j9_authorised_approvers: "authorised posting users: {v}",
        j9_authorised_approvers_empty: "no list set — any posting user accepted",
        j11_senior_roles: "roles: {v}",
        j11_senior_roles_empty: "no roles set — J11 not tested",
        j11_senior_users: "users: {v}",
        j11_senior_users_empty: "no users set",
        j12_limits: "limits: {v}",
        j12_limits_empty: "no limits set — J12 not tested",
        j12_band_pct: "band: {v}%",
        j13_date_window_days: "± {v} days",
      },
      rulesPanel2: {
        guard: "Blank-column guard: ≥ 95% blank ⇒ Not-assessable.",
        savedInline: "Saved. W13 logged.",
        save: "Save",
        edited: "Edited (unsaved)",
      },
      possibleDup2: { expand: "Expand", collapse: "Collapse", xlsx: "XLSX" },
    },
    a9002: {
      title: "Tests of Controls",
      purpose: "One row per control the auditor plans to rely on. Sample from the control population; conclude relied / not relied.",
      noReliance: "N/A — no controls reliance. Record why the audit is fully substantive.",
      reasonLabel: "Reason", reasonPh: "e.g. Small entity — substantive-only approach for FY2025.",
      reasonRequired: "Reason is required.",
      reasonSave: "Save reason", reasonSaved: "Reason saved.",
      col: { ref: "Ref", controlRef: "Control ref", attribute: "Attribute",
              samplePool: "Sample pool", sampleSize: "Sample size",
              exceptions: "Exceptions", conclusion: "Conclusion" },
      conc: { relied: "Relied", notRelied: "Not relied" },
    },
  },
  ar: {
    // Round M3d · proper top-level AR block for the merged JE / Fraud tab.
    // (An older copy at ar.plan.col.a9001 is unreachable — kept intact to
    // avoid touching an already-corrupt AR sibling structure.)
    a9001: {
      title: "اختبار قيود اليومية ومؤشرات الاحتيال \u2066(ISA 240)\u2069",
      subtitle: "محرك واحد · قواعد \u2066J1–J15\u2069 · قيود ضمن الفترة فقط.",
      runScan: "تشغيل الفحص",
      lastRunAt: "آخر تشغيل",
      lastRunBy: "بواسطة",
      workerOn: "العامل",
      workerOff: "أُعيد الحساب",
      outOfDate: "غير محدث — أعد تشغيل الفحص",
      settings: {
        title: "أيام العطل وساعات العمل",
        weekend: "أيام نهاية الأسبوع (أي تركيبة، صفر أو جميع الأيام)",
        weekdays: { 0: "الاثنين", 1: "الثلاثاء", 2: "الأربعاء", 3: "الخميس", 4: "الجمعة", 5: "السبت", 6: "الأحد" },
        holidays: "العطل الرسمية",
        addHoliday: "إضافة عطلة",
        holidayOutside: "يجب أن تقع العطلة الرسمية ضمن فترة الارتباط ± سنة واحدة ({lo} إلى {hi}). تحقق من السنة.",
        removeHoliday: "إزالة",
        workingHours: "ساعات العمل",
        workingStart: "من", workingEnd: "إلى",
        save: "حفظ الإعدادات",
        saved: "تم حفظ الإعدادات.",
        holidayOutsidePeriod: "تحذير: بعض العطل خارج فترة المهمة.",
      },
      possibleDup: {
        title: "احتمال ازدواج — بدون مرجع أو وصف",
        note: "قيود متطابقة في الحساب والمبلغ والتاريخ ولكن بدون مرجع أو وصف؛ تُعرض هنا حتى لا يُبالغ في J13.",
        count: "قيود مكررة محتملة",
      },
      dataQuality: {
        title: "جودة البيانات — قواعد غير قابلة للتقييم",
        note: "لم تُشغَّل القواعد أدناه على هذا المجتمع. أضف العمود الناقص لإزالة الملاحظة.",
        needColumn: "العمود الناقص",
        cols: {
          no_posted_time_column: "posted_time (وقت الترحيل)",
          no_user_column: "posted_by (اسم/معرّف المُعِد)",
          no_approver_column: "approver (اسم/معرّف المعتمد)",
          no_clearly_trivial: "الحد التافه في 105أ",
          no_approval_limit_set: "قائمة حدود الاعتماد في الإعدادات",
          tb_movement_missing: "حركة ميزان المراجعة (ارفع الميزان)",
        },
      },
      cardStatus: { flagged: "مُعلَّم", clean: "لا مؤشرات", notAssessable: "غير قابل للتقييم" },
      cardExpand: "عرض", cardCollapse: "طي",
      cardXlsx: "XLSX", cardTestThese: "اختبر هذه الآن",
      cardDrillCols: { entryDate: "تاريخ القيد", voucher: "القسيمة", account: "الحساب", amount: "المبلغ", reason: "السبب" },
      rulesPanel: {
        title: "القواعد والمعاملات (J1–J15)",
        col: {
          code: "الرمز", name: "الاسم", detects: "ما يكتشفه",
          why: "لماذا يهم", exact: "القاعدة", param: "المُعامِل",
          denom: "المقام", data: "البيانات المطلوبة", edit: "تعديل",
        },
        denom: {
          inPeriod: "قيود ضمن الفترة", inPeriodVouchers: "قسائم ضمن الفترة",
          inPeriodAccounts: "حسابات ضمن الفترة",
          pairs: "أزواج القسائم", withUserCol: "قيود ضمن الفترة مع عمود المستخدم",
          allAmounts: "قيود ضمن الفترة بمبلغ",
        },
        data: {
          entryDate: "entry_date + الفترة",
          postedTime: "posted_time (وقت الترحيل)",
          workingHrs: "أيام العطل + ساعات العمل (الإعدادات)",
          amounts: "المبلغ + الحد التافه (105أ)",
          account: "رمز الحساب",
          accountPair: "زوج حسابات (مدين + دائن)",
          desc: "الوصف / النص",
          reversal: "نفس الحسابات ومبلغ بعلامة معاكسة خلال N يوم",
          user: "posted_by / posted_by_role",
          tb: "حركة ميزان المراجعة",
          limits: "قائمة حدود الاعتماد",
          reference: "المرجع (وإلا الوصف)",
        },
        savedToast: "تم حفظ المُعامِل",
        commaList: "قائمة مفصولة بفواصل",
      },
      a9001_01_opens: "يفتح مع المجموعة",
      j10Title: "J10 · فحص الاكتمال (المجتمع مقابل حركة ميزان المراجعة)",
      j10PopulationSize: "المجتمع",
      j10ExpectedSize: "المتوقع",
      j10Diff: "الفرق",
      j10ReasonRequired: "اشرح الفرق (مطلوب قبل الإرسال إلى العينات)",
      j10ReasonPh: "مثال: 3 قيود افتتاحية مستبعدة وفقًا للسياسة",
      j10Blocked: "اشرح فرق J10 قبل الإرسال.",
      j10NoteOptional: "ملاحظة على J10 (اختيارية — تُسجَّل في ورقة عمل العينات)",
      j10InfoNotAssessed: "لم يُقيَّم اكتمال J10 — مُسجَّل في ورقة العمل",
      j10InfoDiffers: "فرق في تسوية ميزان المراجعة (J10) بمقدار {amount} — مُسجَّل في ورقة العمل",
      j10InfoAgrees: "تسوية ميزان المراجعة (J10) متطابقة — مُسجَّل في ورقة العمل",
      pickAtLeastOne: "اختر مرشحًا واحدًا على الأقل من J.",
      filtersTitle: "مرشحات J1–J15",
      filtersHint: "انقر المرشحات لبناء المجتمع المُرسَل إلى العينات.",
      sendToSampling: "إرسال المجتمع المُصفَّى إلى العينات",
      sendUnit: "({lines} سطر · {vouchers} سند)", sendDisabledJ10: "محظور: فرق في تسوية ميزان المراجعة (J10) — أدخل السبب أولًا", sendDisabledPick: "اختر مرشّحًا أو أكثر أعلاه",
      sentToSampling: "تم إرسال {size} صفًا إلى العينات.",
      a9001_03_link: "سجلات العينات",
      a9001_04_link: "سجلات التدقيق",
      truncated: "عرض أول 200 قسيمة.",
      col: { voucher: "القسيمة", lines: "السطور", flags: "الإشارات",
              entryDate: "تاريخ القيد", account: "الحساب", amount: "المبلغ" },
      enqueuing: "جارٍ إدراج مهمة تسجيل J1–J15 في قائمة الانتظار…",
      noScanYet: "لم يُجرَ أي فحص بعد — انقر «تشغيل الفحص»",
      chipUnits: "{lines} سطرًا ({vouchers} مستندًا)",
      dupLines: { title: "أسطر مخزّنة أكثر من مرة", note: "نفس الحساب والتاريخ والمبلغ والمستند والبيان — تكرار من تحميل الدفتر، يُعدّ بمعزل عن J13 (الذي لا يقرن أسطر المستند الواحد).", count: "{n} سطرًا في {g} مجموعات", list: "عرض الأسطر", none: "لا يوجد" },
      computedWithoutWorker: "أُعيد الحساب",
      attr: {
        J1: "نافذة نهاية الفترة", J2: "مرحّل بعد نهاية الفترة",
        J3: "عطلة/عطلة رسمية/خارج ساعات العمل", J4: "مبلغ مقرّب",
        J5: "حساب نادر الاستخدام", J6: "تركيبة حسابات غير معتادة",
        J7: "وصف فارغ أو قصير", J8: "قيد وعكسه",
        J9: "مستخدم مُرحِّل ليس ضمن القائمة المعتمدة", J10: "فحص الاكتمال",
        J11: "تجاوز الإدارة العليا", J12: "مبلغ أدنى بقليل من حد الاعتماد",
        J13: "قيد مكرر",
        J14: "المعتمد فارغ", J15: "المعتمد = المُرحِّل",   // Batch 31 · item 12 (M95)
      },
      rule: {
        J1: "تاريخ القيد ضمن N يوم قبل أو بعد نهاية الفترة.",
        J2: "التوقيت المسجل بعد نهاية الفترة.",
        J3: "تاريخ القيد يوم عطلة أسبوعية أو رسمية، أو مُرحَّل خارج ساعات العمل.",
        J4: "المبلغ ≥ الحد التافه (105أ) وقابل للقسمة على 1,000.",
        J5: "الحساب مُرحَّل إليه ≤ N قيود خلال الفترة.",
        J6: "تركيبة مدين/دائن تظهر في < N% من القسائم.",
        J7: "وصف بأقل من N حرفًا.",
        J8: "قسيمة عكستها قسيمة لاحقة (نفس الحسابات، مبلغ متساوٍ ومعاكس) خلال N يوم.",
        J9: "المستخدم المُرحِّل فارغ، أو ليس ضمن قائمة المستخدمين المعتمدين عند ضبطها.",
        J10: "إجمالي المدين والدائن للفترة = حركة ميزان المراجعة.",
        J11: "قيد أعده أو اعتمده منصب إدارة عليا (افتراضي: شريك) أو مستخدم من القائمة.",
        J12: "مبلغ ضمن نطاق (5% افتراضياً) أدنى من أي حد اعتماد مضبوط.",
        J13: "نفس الحساب والمبلغ والتاريخ والمرجع (أو الوصف) على قسيمتين مختلفتين.",
        J14: "عمود المعتمد فارغ في السطر (فقط عند تعيين عمود المعتمد في استيراد دفتر الأستاذ).",
        J15: "المعتمد هو نفس المستخدم المُرحِّل (اعتماد ذاتي).",
      },
      why: {
        J1: "التسويات المتأخرة عند القطع مؤشر تجاوز كلاسيكي.",
        J2: "قيود بتاريخ داخل السنة وتوقيت رسمي بعد نهايتها تستحق المراجعة.",
        J3: "الترحيل في العطل أو خارج ساعات العمل غير معتاد للنشاط الطبيعي.",
        J4: "المبالغ المقرّبة قرب الحد التافه قد تُستخدم لتنعيم النتائج.",
        J5: "الحسابات النادرة الاستخدام غالبًا ما تُستخدم لتسويات يدوية استثنائية.",
        J6: "زوج حسابات لا يظهر معًا في العادة يستحق سؤالًا.",
        J7: "الأوصاف الفارغة أو المختصرة تُخفي المبرر التجاري.",
        J8: "أنماط ترحيل ثم عكس قد تنقل الأرصدة عبر نهاية الفترة.",
        J9: "الترحيل من مستخدمين خارج القائمة المعتمدة يتجاوز فصل المهام.",
        J10: "أستاذ لا يطابق حركة الميزان يعني مجتمعًا ناقصًا.",
        J11: "الشركاء / المدراء الذين يرحّلون قيودهم بأنفسهم يتجاوزون الفحص.",
        J12: "تجزئة المبلغ ليقل قليلاً عن حد الاعتماد إشارة حمراء.",
        J13: "نفس الفاتورة مسجلة على قسيمتين مؤشر شائع لازدواج الدفع.",
        J14: "القيد الذي لم يعتمده أحد لم يخضع لمراجعة ثانية.",
        J15: "القيد الذي يعتمده من رحّله يتجاوز فصل المهام.",
      },
      legend: {
        title: "دليل السمات",
        code: "الرمز", name: "الاسم", rule: "القاعدة", param: "المعلمة الحالية",
        denom: "المقام",
        paramNote: "المعلمات مأخوذة من ورقة المواصفات 5 ويمكن للشريك تعديلها.",
      },
      paramsSaved: "تم حفظ المعلمات.",
      notApplicableTbOnly: "لا ينطبق — هذه المهمة تحوي ميزان مراجعة فقط (لا قيود يومية في دفتر الأستاذ). يتطلب اختبار قيود اليومية دفتر الأستاذ. المصدر: ميزان المراجعة المرفوع.",
      periodMissing: "لم يتم ضبط فترة المهمة — يرجى حفظ تاريخي بداية ونهاية الفترة في إعدادات المهمة قبل تشغيل اختبار قيود اليومية.",
      readCapped: "فحص جزئي: قرأ هذا الفحص {read} من أصل {total} صفًا في الأستاذ العام (الحد الأقصى لفحص واحد {cap}). الاختبارات والأعداد أدناه تغطي هذه الصفوف ({read}) فقط.",
      rowsRange: "الصفوف {from}–{to} من {total}",
      rowsPrev: "السابق",
      rowsNext: "التالي",
      rowsPageOf: "الصفحة {page} من {pages}",
      j10Debits: "المدين", j10Credits: "الدائن",
      j10TbMovement: "حركة ميزان المراجعة", j10TbMissing: "حركة ميزان المراجعة غير متاحة",
      params: { show: "تعديل المعلمات", hide: "إخفاء المعلمات" },
      paramLabel: {
        j1_window_days: "نافذة J1 (± أيام)",
        j5_max_postings: "أقصى قيود لكل حساب في J5",
        j6_pair_pct: "ندرة الزوج في J6 (٪)",
        j7_min_len: "أدنى طول للوصف في J7",
        j8_reversal_days: "نافذة عكس J8 (أيام)",
      },
      telemetry: {
        title: "قياسات المجتمع",
        period: "الفترة", totalRows: "إجمالي صفوف الأستاذ",
        parsedDates: "صفوف بتاريخ مقروء",
        inPeriod: "ضمن الفترة", before: "قبل الفترة", after: "بعد الفترة",
        j6NotAssessable: "J6 غير قابل للتقييم (قسائم غامضة)",
        j9Column: "عمود المُعِد متاح",
      },
      outside: {
        show: "عرض {n} قيدًا خارج الفترة",
        hide: "إخفاء القيود خارج الفترة",
        title: "قيود خارج الفترة",
      },
      cardGridTitle: "قواعد J1–J15",
      lineWord: "سطر", linesWord: "سطور",
      voucherWord: "سند", vouchersWord: "سندات",
      popWord: "من المجتمع",
      notAssessableDash: "—",
      guardNote: "حارس الأعمدة الفارغة: تصبح القاعدة «غير قابلة للتقييم» عندما يكون العمود الذي تعتمد عليه فارغًا في 95٪ فأكثر من قيود الفترة.",
      writeOnViewNote: "فتح الصفحة لا يكتب شيئًا — يعمل الفحص فقط عند الضغط على زر «تشغيل الفحص».",
      cardParam: {
        J2: "مُرحَّل بعد نهاية الفترة",
        J3: "عطل نهاية الأسبوع + العطل الرسمية + ساعات العمل (الإعدادات)",
        J4tpl: "≥ {trivial} · قابل للقسمة على {mult}",
        J4tplDefault: "≥ الحد التافه (105أ) · قابل للقسمة على {mult}",
        J10: "إجمالي المدين / الدائن مقابل حركة ميزان المراجعة",
        J14: "عمود المعتمد (استيراد دفتر الأستاذ)", J15: "عمود المعتمد (استيراد دفتر الأستاذ)",   // Batch 31 · item 12 (M95)
        j3Used: "العطلة المستخدمة: {days} · ساعات العمل {start}–{end}",   // Batch 31 · item 30 (M106)
        wdShort: "الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد",
      },
      paramFormat: {
        j1_window_days: "± {v} يوم",
        j5_max_postings: "≤ {v} قيود",
        j6_pair_pct: "زوج < {v}٪ من القسائم",
        j7_min_len: "< {v} حرفًا",
        j8_reversal_days: "عكس خلال {v} يوم",
        j4_min_amount: "أدنى {v}",
        j4_multiple_of: "قابل للقسمة على {v}",
        j9_authorised_approvers: "المستخدمون المُرحِّلون المعتمدون: {v}",
        j9_authorised_approvers_empty: "لا توجد قائمة — يُقبل أي مستخدم مُرحِّل",
        j11_senior_roles: "الأدوار: {v}",
        j11_senior_roles_empty: "لا أدوار مضبوطة — J11 لا يُختبر",
        j11_senior_users: "المستخدمون: {v}",
        j11_senior_users_empty: "لا مستخدمون مضبوطون",
        j12_limits: "الحدود: {v}",
        j12_limits_empty: "لا حدود مضبوطة — J12 لا يُختبر",
        j12_band_pct: "النطاق: {v}٪",
        j13_date_window_days: "± {v} يوم",
      },
      detects: {
        J1: "قيود بتاريخ ضمن نافذة قصيرة حول نهاية الفترة.",
        J2: "قيود بتاريخ داخل الفترة لكن توقيتها بعد نهاية السنة.",
        J3: "قيود في العطل الأسبوعية أو الرسمية أو خارج ساعات العمل.",
        J4: "مبالغ مقرّبة عند أو فوق الحد التافه وقابلة للقسمة.",
        J5: "حسابات تلقت قيودًا قليلة جدًا خلال الفترة كاملة.",
        J6: "أزواج حسابات مدين / دائن نادرة الظهور معًا.",
        J7: "قيود ذات وصف قصير جدًا أو فارغ.",
        J8: "قسائم عُكست بعد أيام بقسيمة مساوية ومعاكسة.",
        J9: "قيود بمستخدم مُرحِّل فارغ أو ليس ضمن القائمة المعتمدة.",
        J10: "هل يتطابق مجموع المجتمع مع حركة ميزان المراجعة.",
        J11: "قيود أعدها أو اعتمدها منصب/مستخدم من الإدارة العليا.",
        J12: "مبالغ أدنى بقليل من حد اعتماد مضبوط.",
        J13: "نفس الحساب والمبلغ والتاريخ والمرجع/الوصف على قسيمتين.",
        J14: "قيود بلا معتمد مسجل.",
        J15: "قيود اعتمدها نفس المستخدم الذي رحّلها.",
      },
      reason: {
        J1: "تاريخ القيد ضمن ± {n} يوم من نهاية الفترة.",
        J2: "التوقيت بعد نهاية الفترة.",
        J3: "عطلة أسبوعية أو رسمية أو خارج ساعات العمل.",
        J4: "مبلغ مقرّب ≥ الحد التافه وقابل للقسمة على {mult}.",
        J5: "الحساب مُرحَّل ≤ {n} قيود في الفترة.",
        J6: "زوج حسابات نادر (< {pct}٪ من القسائم).",
        J7: "وصف بأقل من {n} حرفًا.",
        J8: "عكسته قسيمة مساوية ومعاكسة خلال {n} يوم.",
        J9: "المستخدم المُرحِّل فارغ أو ليس ضمن القائمة المعتمدة.",
        J10: "المدين / الدائن لا يساوي حركة الميزان.",
        J11: "أعده / اعتمده منصب أو مستخدم إدارة عليا.",
        J12: "مبلغ ضمن {pct}٪ أدنى من حد اعتماد.",
        J13: "قيد مكرر — نفس الحساب والمبلغ والتاريخ والمرجع / الوصف على قسيمة أخرى.",
        J14: "لا يوجد معتمد في السطر.",
        J15: "اعتمده المستخدم المُرحِّل نفسه.",
      },
      paramLabelPlain: {
        j1_window_days: "نافذة J1 (± أيام)",
        j5_max_postings: "أقصى قيود لكل حساب في J5",
        j6_pair_pct: "عتبة ندرة الزوج J6 (٪)",
        j7_min_len: "أدنى طول للوصف في J7 (حرف)",
        j8_reversal_days: "نافذة عكس J8 (أيام)",
        j4_min_amount: "الحد الأدنى للمبلغ في J4 (0 = استخدم الحد التافه)",
        j4_multiple_of: "J4 قابل للقسمة على",
        j9_authorised_approvers: "المستخدمون المُرحِّلون المعتمدون في J9",
        j11_senior_roles: "أدوار الإدارة العليا في J11",
        j11_senior_users: "مستخدمو الإدارة العليا في J11",
        j12_limits: "قائمة حدود الاعتماد في J12",
        j12_band_pct: "النطاق أسفل الحد في J12 (٪)",
        j13_date_window_days: "نافذة التاريخ في J13 (± أيام)",
      },
      dqExplain: {
        no_posted_time_column: "لا يوجد عمود وقت الترحيل — لا يمكن اختبار J2 / J3 خارج ساعات العمل.",
        no_user_column: "لا يوجد عمود المُعد — لا يمكن اختبار J9 و J11.",
        no_approver_column: "لم يُستورد عمود المعتمد — لا يمكن اختبار J14 و J15. عيّن عمود المعتمد عند استيراد دفتر الأستاذ.",
        no_clearly_trivial: "الحد التافه غير مضبوط في 105(أ) — لا يمكن اختبار J4.",
        no_approval_limit_set: "لا توجد قائمة حدود اعتماد — لا يمكن اختبار J12.",
        tb_movement_missing: "حركة ميزان المراجعة غير متاحة — لا يمكن اختبار اكتمال J10.",
        column_blank_ge_95pct: "العمود الذي تقرأه هذه القاعدة فارغ في 95٪ فأكثر من قيود الفترة — عيّن العمود الصحيح.",
      },
      dqSuggest: {
        J7: "عيّن عمود النص / الوصف",
        J9: "عيّن عمود posted_by (اسم أو معرّف المُعد)",
        J10: "ارفع ميزان المراجعة",
        J11: "عيّن عمود posted_by_role",
        J13: "عيّن عمود المرجع أو الوصف",
        J14: "عيّن عمود المعتمد عند استيراد دفتر الأستاذ", J15: "عيّن عمود المعتمد عند استيراد دفتر الأستاذ",
      },
      rulesPanel2: {
        guard: "حارس الأعمدة الفارغة: فراغ ≥ 95٪ يعني غير قابل للتقييم.",
        savedInline: "تم الحفظ. سُجل في W13.",
        save: "حفظ",
        edited: "معدّل (لم يُحفظ)",
      },
      possibleDup2: { expand: "عرض", collapse: "طي", xlsx: "XLSX" },
    },
    a9002: {
      title: "اختبارات الضوابط",
      purpose: "صف واحد لكل ضابط ينوي المراجع الاعتماد عليه. اسحب عينة من مجتمع الضابط وخلُص إلى «معتمَد» أو «غير معتمَد».",
      noReliance: "غير منطبق — لا يوجد اعتماد على الضوابط. سجّل سبب اعتماد المنهج الجوهري بالكامل.",
      reasonLabel: "السبب",
      reasonPh: "مثال: منشأة صغيرة — منهج جوهري بالكامل للسنة المالية 2025.",
      reasonRequired: "السبب مطلوب.",
      reasonSave: "حفظ السبب",
      reasonSaved: "تم حفظ السبب.",
      col: {
        ref: "المرجع", controlRef: "مرجع الضابط", attribute: "السمة",
        samplePool: "مجتمع العينة", sampleSize: "حجم العينة",
        exceptions: "الاستثناءات", conclusion: "الاستنتاج",
      },
      conc: { relied: "معتمَد", notRelied: "غير معتمَد" },
    },
    tcwg: {
      // C3b · N2 — 311(a) communication-log UI labels (AR).
      tableHint: "إضافة / تعديل فقط. لا يمكن الحذف (\u2066ISA 230\u2069).",
      addBtn: "إضافة موضوع",
      empty: "لا توجد اتصالات مسجَّلة بعد.",
      savedOk: "تم حفظ الاتصال.",
      errCategoryRequired: "التصنيف مطلوب.",
      errMatterRequired: "الموضوع مطلوب.",
      col: {
        category: "التصنيف",
        matter: "الموضوع",
        linkedRef: "المرجع المرتبط",
        date: "التاريخ",
        mode: "الأسلوب",
        to: "أُبلغ إلى",
        toRole: "الصفة",
        response: "الرد",
        followup: "متابعة",
      },
      cat: {
        auditor_responsibilities: "مسؤوليات المراجع",
        planned_scope_and_timing: "النطاق والتوقيت المخطَّط",
        significant_findings: "النتائج الجوهرية",
        independence_listed: "الاستقلال (المنشآت المُدرَجة)",
        other: "أخرى",
      },
      mode: {
        oral: "شفهي",
        written: "كتابي",
      },
      w9AddBtn: "إضافة إلى سجل \u2066311(a)\u2069",
      w9ChipPrefix: "مُسجَّل في \u2066311(a)\u2069:",
      // U2 · category translations for W11 detail + log-card rendering.
      category: {
        significant_findings: "النتائج الجوهرية",
        auditor_responsibilities: "مسؤوليات المراجع",
        planned_scope: "النطاق والتوقيت المخطَّط",
        significant_difficulties: "الصعوبات الجوهرية",
        management_letter: "خطاب الإدارة",
        independence: "أمور الاستقلال",
        misstatements: "التحريفات",
        other: "أخرى",
      },
      // S1 — flat W13 keys AR side.
      "w13.action.tcwg_311a_log_added": "أُضيف صف سجل \u2066311(a)\u2069",
      "w13.action.tcwg_311a_log_patched": "عُدِّل صف سجل \u2066311(a)\u2069",
      "w13.action.tcwg_311a_log_backfilled": "تعبئة تلقائية — فشل الكتابة الأصلية",
      "w13.entity.tcwg_311a_log": "سجل اتصالات \u2066311(a)\u2069",
      // C3b · P3/P5 — العناوين وملاحظات وضع المراجعة.
      sectionTitle: "سجل الاتصالات",
      saveFailed: "تعذَّر حفظ الاتصال. يرجى المحاولة مرة أخرى.",
      auditWriteFailed: "تعذَّر تسجيل الاتصال في سجل التدقيق. لم يُحفظ الصف.",
      reviewNote: "ارتباط فحص (نطاق الممارس) — يبقى السجل فعّالاً؛ استخدم صياغة الفحص.",
      reviewBanner: "ارتباط فحص — الاتصالات مع المكلفين بالحوكمة ضمن نطاق الممارس.",
      catReview: {
        auditor_responsibilities: "مسؤوليات الممارس",
      },
      linkedRefs: {
        "W9-tcwg-communicated": {
          label: "\u2066W9\u2069 — أُبلغ المكلفون بالحوكمة",
          href: "/completion/misstatements",
        },
      },
      // Q6 — Arabic labels for the tcwg_311a W13 action codes.
      w13Actions: {
        tcwg_311a_log_added: "أُضيف صف سجل \u2066311(a)\u2069",
        tcwg_311a_log_patched: "عُدِّل صف سجل \u2066311(a)\u2069",
        tcwg_311a_log_backfilled: "تعبئة تلقائية للسجل — فشل الكتابة الأصلية",
      },
      // Q5 — Review-engagement overrides for 311(a) form (no ISA text
      // reproduced; refs left blank per Batch E spec).
      reviewOverrides: {
        section1Title: "الاتصالات المطلوبة (ارتباط فحص)",
        item_1: "تم توضيح مسؤوليات الممارس المتعلقة بارتباط الفحص للمكلفين بالحوكمة.",
        item_2: "تم إبلاغ النطاق والتوقيت المخطَّط للفحص، بما في ذلك المخاطر الجوهرية المحدَّدة.",
        item_3: "تم إبلاغ النتائج الجوهرية من الفحص، بما في ذلك الجوانب النوعية المهمة والصعوبات الجوهرية.",
        item_4: "تم إبلاغ الظروف التي تؤثر على شكل ومحتوى تقرير الممارس، إن وجدت.",
        item_5: "تم إبلاغ الإفادات الخطية المطلوبة.",
        item_6: "تم إبلاغ الأمور المتعلقة بالاستقلال.",
        item_7: "تم إبلاغ التحريفات غير المصحَّحة وأثرها على الاستنتاج (إحالة إلى ملخص التحريفات).",
      },
    },
    materiality: {
      figuresTitle: "أرقام الأهمية النسبية",
      priorYearRef: "السنة السابقة (السنة المالية {fy}) — للاطلاع فقط؛ لا تُرحَّل الأهمية النسبية",
      priorOverall: "الأهمية النسبية الإجمالية",
      priorPm: "أهمية الأداء",
      priorCt: "الحد غير المؤثر بوضوح",
      // Batch 27 · D (M37)
      ctNotSet: "لم يُحدَّد الحد غير المؤثر بوضوح — أدخل نسبته.",
      ctNotSetIn105a: "لم يُحدَّد الحد غير المؤثر بوضوح في 105(a).",
      open105a: "افتح 105(a)",
      priorBenchmark: "الأساس",
      benchmark: "المؤشر المرجعي",
      benchmarkAmount: "مبلغ المؤشر المرجعي",
      pctApplied: "النسبة المطبقة",
      overall: "الأهمية النسبية الإجمالية",
      overallCalc: "المحسوب: {v}",
      savedToast: "تم حفظ المادية",
      overrideNote: "متجاوَز — السبب: {reason}",
      pmPct: "نسبة الأهمية النسبية للتنفيذ",
      pm: "الأهمية النسبية للتنفيذ",
      ctPct: "نسبة حد المبالغ التافهة بشكل واضح",
      ct: "حد المبالغ التافهة بشكل واضح",
      specific: "أهمية نسبية محددة",
      specificTitle: "أهمية نسبية محددة (لكل بند مالي)",
      specificAdd: "إضافة صف",
      specificEmpty: "لا توجد أهمية نسبية محددة. أضف صفًا فقط إذا كان هناك حد أدنى لفئة/رصيد/إفصاح معين.",
      specificFsHead: "بند القوائم",
      specificAmount: "المبلغ",
      specificReason: "السبب",
      rationale: "المبررات",
      revise: "تعديل الأهمية النسبية",
      reason: "سبب التعديل",
      history: "سجل التعديلات",
      historyCols: { when: "التاريخ والوقت", who: "المستخدم", field: "الحقل",
        old: "القيمة السابقة", new: "القيمة الجديدة", reason: "السبب" },
      fields: {
        benchmark: "المرجع",
        amount: "مبلغ المرجع",
        omPct: "نسبة الأهمية النسبية الإجمالية",
        pmPct: "نسبة أهمية الأداء",
        ctPct: "نسبة الحد الجوهري بشكل واضح",
        rationale: "المبررات",
        overallMateriality: "الأهمية النسبية الإجمالية",
        performanceMateriality: "أهمية الأداء",
        clearlyTrivial: "حد التحريفات الجوهرية بشكل واضح",
        migration: "الترحيل من تقييم المخاطر",
      },
      overrideReason: "سبب تجاوز القيمة المحسوبة",
      open105: "افتح 105(a)",
      readOnlyBanner: "للقراءة فقط — يُحدَّد في 105(a)",
      migrated: "نُقلت من تقييم المخاطر",
      newEngagementNote: "قيمة أولية. بعد الإنشاء، تتغير الأهمية النسبية فقط في النموذج 105(a).",
      pmSource: "المصدر: 105(a)",
      benchmarks: { pbt: "الربح قبل الضريبة", revenue: "الإيرادات",
        totalAssets: "إجمالي الأصول", equity: "حقوق الملكية",
        expenses: "إجمالي المصروفات", other: "أخرى" },
    },
    plan: {
      title: "خطة الاستجابة للمراجعة",
      empty: "لا توجد مخاطر في السجل — أضف المخاطر في تقييم المخاطر أولًا.",
      addPlan: "تعيين الخطة",
      specificallyResponsive: "مستجيب بشكل محدد",
      controlsReliance: "الاعتماد على الضوابط",
      significant: "خطر مهم",
      col: { risk: "الخطر", fsHead: "البنود", assertions: "الإقرارات",
              planned: "الإجراءات المخطط لها", status: "الاستجابة مكتملة",
              regFsArea: "المجال بالسجل",
              rmm: "مستوى المخاطر", significant: "مهم" },
      pickHead: "اختر البند / البنود",
      pickAssertion: "اختر الإقرارات",
      noHeads: "لا توجد بنود قوائم مالية مُعرَّفة لهذه المهمة.",
      library: "مكتبة الإجراءات (مُصفّاة)",
      picked: "الإجراءات المختارة",
      addFromLibrary: "إضافة إلى الخطة",
      remove: "إزالة",
      nature: { tod: "اختبار التفاصيل", sap: "إجراءات تحليلية جوهرية", toc: "اختبار الضوابط" },
      timing: { interim: "مرحلية", final: "نهائية" },
      extent: "المدى",
      extentPh: "مثال: عينة 25 عنصرًا > الأهمية النسبية",
      wpLink: "رابط ورقة العمل",
      wpLinkPh: "مثال: 4101-04",
      formsSection: {
        title: "نماذج الاستجابة للمراجعة",
        empty: "النموذجان 108(أ) و 202(أ) غير مضافين بعد إلى هذه المهمة.",
        ref: "المرجع",
        name: "النموذج",
        folder: "الموقع",
        open: "فتح النموذج",
      },
      badge: {
        r1: "يلزم إجراء واحد على الأقل.",
        r1FsHead: "اختر بندًا واحدًا على الأقل لتصفية مكتبة الإجراءات.",
        r2: "الخطر المهم يستلزم إجراءً مستجيبًا بشكل محدد على الأقل.",
        r3: "الخطر المهم بدون اعتماد على الضوابط يستلزم اختبار تفاصيل على الأقل.",
        cf: "حدّث للسنة الحالية",
      },
      summary: {
        title: "خطة الاستجابة — ملخص للقراءة فقط",
        readOnlyNote: "مغذّى من خطة الاستجابة للمراجعة · للقراءة فقط",
        risk: "الخطر",
        fsHead: "البنود",
        assertions: "الإقرارات",
        significant: "مهم",
        plannedCount: "الإجراءات المخططة",
        status: "التحقق",
      },
    },
  },
};

export default I18N_BASE_PLANNING;
